import _ from 'lodash';
import { PatientForm, PatientFormTemplate } from 'requests/resources';

import { PatientFormStatus, UserBase } from '@lib/resources/types';
import { createQuestion } from '@lib/services/patientFormsService';

/**
 * Create flow (PatientForm) for the new selected flow template (PatientFormTemplate)
 */
export const getLumaBotFlow = (currentUser: UserBase, flowTemplate: PatientFormTemplate): Partial<PatientForm> => {
  const currentItemId = _.get(_.head(flowTemplate.template.items), 'id', '');
  const path = [currentItemId];
  const pages = [{ questions: _.map(flowTemplate.template.items, (item) => createQuestion(item)) }];
  return {
    patient: currentUser.$isWidgetUser ? undefined : currentUser.id,
    patientFormTemplate: flowTemplate._id as any,
    status: PatientFormStatus.Started,
    responses: { currentItemId, path, pages },
  };
};
